<template>
  <div class="help-page">
    <NavBar />
    <AuthBySessionExpired />

    <div class="help-container">
      <b-overlay :show="loading" opacity="0.99" class="help-overlay">
        <!-- Header Section -->
        <div class="help-header">
          <v-btn class="btn-return" @click="handleToBack">
            <i class="fas fa-arrow-left mr-2"></i>
            VOLTAR
          </v-btn>
          <div class="help-title-section">
            <h1 class="help-main-title">Central de Ajuda</h1>
            <p class="help-subtitle">
              Acesse os recursos de treinamento e documentação
            </p>
          </div>
        </div>

        <!-- Empty State -->
        <div v-if="data.length == 0" class="empty-state">
          <div class="empty-state-icon">
            <i class="fas fa-book-open"></i>
          </div>
          <h3>Nenhum recurso disponível</h3>
          <p>Os recursos de ajuda ainda não foram configurados.</p>
        </div>

        <!-- Help Cards Grid -->
        <div v-else class="help-grid">
          <div class="help-card-wrapper" v-for="(item, key) in data" :key="key">
            <div class="help-card" @click="handleToDrive(item.link)">
              <div class="help-card-icon">
                <i class="fas fa-sticky-note"></i>
              </div>
              <div class="help-card-content">
                <h3 class="help-card-title">{{ item.title }}</h3>
              </div>
              <div class="help-card-action">
                <span class="help-card-link">
                  <i class="fas fa-external-link-alt mr-1"></i>
                  Acessar
                </span>
              </div>
            </div>
          </div>
        </div>

        <ErrorsMessages :errors="errors" />
      </b-overlay>
    </div>
  </div>
</template>

<script>
import NavBar from "../templates/NavBar";
import AuthBySessionExpired from "../templates/Components/AuthBySessionExpired";
import ErrorsMessages from "../templates/Components/ErrorsMessages";

import api from "../services/api";
import routes from "../routes";

export default {
  name: "Help",

  components: {
    NavBar,
    AuthBySessionExpired,
    ErrorsMessages,
  },

  data() {
    return {
      data: [],
      errors: [],
      loading: false,
    };
  },

  created() {
    this.retrieve();
  },

  methods: {
    async retrieve() {
      try {
        this.loading = true;

        const response = await api.get("/help");
        const { error, errors, data } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.data = data;
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },

    handleToBack() {
      if (!routes.go(-1)) {
        routes.push({ name: "dashboard" });
      } else {
        routes.go(-1);
      }
    },

    handleToDrive(link) {
      window.open(link, "_blank");
    },
  },
};
</script>

<style scoped>
.help-page {
  min-height: 100vh;
  background: #f8fafc;
}

.help-container {
  max-width: 1400px;
  margin: 0 auto;
}

.help-overlay {
  padding: 2rem;
  min-height: calc(100vh - 80px);
}

/* Header */
.help-header {
  margin-bottom: 3rem;
}

.help-title-section {
  text-align: center;
  margin-bottom: 1rem;
}

.help-main-title {
  font-size: 2.5rem;
  font-weight: 700;
  color: #0f65b0;
  margin-bottom: 0.5rem;
}

.help-subtitle {
  font-size: 1.1rem;
  color: #666;
  margin: 0;
}

/* Empty State */
.empty-state {
  text-align: center;
  padding: 4rem 2rem;
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  margin: 2rem auto;
  max-width: 500px;
}

.empty-state-icon {
  font-size: 4rem;
  color: #ddd;
  margin-bottom: 1.5rem;
}

.empty-state h3 {
  color: #0f65b0;
  margin-bottom: 0.5rem;
  font-size: 1.5rem;
}

.empty-state p {
  color: #666;
}

/* Grid Layout */
.help-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
  gap: 1.5rem;
  margin-top: 2rem;
}

.help-card {
  background: #fff;
  border-radius: 16px;
  padding: 2rem;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;
  cursor: pointer;
  position: relative;
  min-height: 200px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  border: 1px solid #e5e7eb;
}

.help-card::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: #4e9130;
  transform: scaleX(0);
  transition: transform 0.3s ease;
}

.help-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.12);
}

.help-card:hover::before {
  transform: scaleX(1);
}

.help-card-icon {
  width: 60px;
  height: 60px;
  border-radius: 16px;
  background: #4e9130;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 1.5rem;
  color: #fff;
  font-size: 1.5rem;
}

.help-card-content {
  flex: 1;
  margin-bottom: 1rem;
}

.help-card-title {
  font-size: 1.1rem;
  font-weight: 700;
  color: #0f65b0;
  margin: 0;
  line-height: 1.3;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.help-card-action {
  display: flex;
  justify-content: flex-end;
  margin-top: 1rem;
}

.help-card-link {
  color: #4e9130;
  font-weight: 600;
  font-size: 0.9rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  transition: all 0.3s ease;
}

.help-card:hover .help-card-link {
  color: #0f65b0;
  transform: translateX(4px);
}

/* Responsive Design */
@media (max-width: 768px) {
  .help-overlay {
    padding: 1rem;
  }

  .help-main-title {
    font-size: 2rem;
  }

  .help-grid {
    grid-template-columns: 1fr;
    gap: 1rem;
  }

  .help-card {
    padding: 1.5rem;
    min-height: 180px;
  }

  .help-card-icon {
    width: 50px;
    height: 50px;
    font-size: 1.25rem;
  }

  .help-card-title {
    font-size: 1rem;
  }
}

@media (max-width: 480px) {
  .help-overlay {
    padding: 0.5rem;
  }

  .help-main-title {
    font-size: 1.75rem;
  }

  .help-subtitle {
    font-size: 1rem;
  }
}

/* Focus */
.help-card:focus {
  outline: 2px solid #4e9130;
  outline-offset: 2px;
}
</style>